import React from 'react'
import { STATICS } from 'statics'
import { REFER_FRIEND_REGULATION } from 'app-constants'
import { CouponButton } from './components'
import './style.scss'

export function ReferFriendModal() {
  return (
    <div className='container-refer-friend'>
      <span className='title'>Convide e Ganhe!</span>
      <div className='container-image'>
        <STATICS.REFER_FRIEND />
      </div>
      <div className='container-info'>
        <span className='text'>
          Você tem um <strong>cupom exclusivo</strong> esperando para ser usado! Compartilhe com
          amigos, vizinhos ou familiares e aproveite os benefícios:
        </span>
        <ul className='list'>
          <li className='list-item'>
            <strong>Seu amigo</strong> recebe <strong>20% de desconto</strong> por 2 meses após
            ativar o plano.
          </li>
          <li className='list-item'>
            <strong>Você</strong> ganha <strong>1 fatura 100% grátis</strong> quando ele pagar a
            primeira fatura!
          </li>
        </ul>
        <span className='text'>Acesse seu cupom agora e comece a compartilhar!</span>
        <CouponButton />
      </div>
      <span className='title'>Como usar seu cupom</span>
      <div className='container-steps'>
        <ul className='step-list'>
          <li className='list-item'>Compartilhe seu código com quem você quiser</li>
          <li className='list-item'>
            Peça para que seu amigo acesse o site da Giga+ e escolha um dos planos
          </li>
          <li className='list-item'>
            Basta seu amigo inserir o código no momento da assinatura no campo: Código de desconto,
            e finalizar o pedido
          </li>
        </ul>
        <span className='text'>
          Para conferir mais sobre o programa, consulte o{' '}
          <a href={REFER_FRIEND_REGULATION} className='link' target='_blank' rel='noreferrer'>
            regulamento
          </a>
          .
        </span>
      </div>
    </div>
  )
}
